import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { SearchService } from '../../service/search.service';
import { AdminSearch, SearchTagCheckbox, SearchTag, FinderData } from '../../model/search';
import { FormControl } from '@angular/forms';
import { AnnotationService } from '../../service/annotation.service';
import { RoiService } from '../../service/roi.service';
import { ClassificationService } from '../../service/classification.service';
import { Subscription } from 'rxjs';
import { UserService } from '../../service/user.service';
import 'parse';
import { I18n } from '@ngx-translate/i18n-polyfill';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-finder-admin',
  templateUrl: './finder-admin.component.html',
  styleUrls: ['./finder-admin.component.less']
})

export class FinderAdminComponent implements OnInit, OnDestroy {

  isSuperAdmin: boolean = false;
  limit = new FormControl();
  subscription: Subscription;
  currentId: string;
  finderData: FinderData;

  @Output() changeAdminData = new EventEmitter();

  constructor(public _searchService: SearchService,
    private readonly i18n: I18n,
    private readonly _annotationService: AnnotationService,
    readonly _classificationService: ClassificationService) {
    this.ngOnInit()
  }

  ngOnInit() {
    this.finderData = this._searchService.finderData


    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    this.currentId = parse.User.current().id
    if (!this.isSuperAdmin)
      return;

    if (!this.finderData.admin.limit || this.finderData.admin.limit < 15)
      this.limit.setValue(15)
    else {
      this.limit.setValue(this.finderData.admin.limit)
    }

    this.subscription = this._classificationService.listTagsObs
      .subscribe((admin) => {
        console.log('change list tag classification');
        this.onChange()
        this.onChangeShowReload()
        this.editListCheckbox()
        this.validate()
      });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe()
  }


  updateSearchTagsAdmin(tags: SearchTagCheckbox[]) {
    this.finderData.admin.searchTags = tags;

  }



  removeSearchTagsAdmin(reset: boolean, tag?: SearchTag,) {
    console.log('remove tag ', tag, reset)
    if (reset) {
      this.finderData.admin.hd.hd = false;
      this.finderData.admin.hd.nHd = false;
      this.finderData.admin.xhd.xhd = false;
      this.finderData.admin.xhd.nxHd = false;
      this.finderData.admin.note.note = false;
      this.finderData.admin.note.nNote = false;
      this.limit = new FormControl()
      this.finderData.admin.limit = 15;
      this.finderData.admin.damageSearch = false;
      this.finderData.admin.annotateSearch = false;
      Object.values(this.finderData.admin.searchTagList).forEach(list => {
        if (list)
          list.forEach(element => {
            element.checked = false;
          });
      });
      $("#dropdownadmin").removeClass('active');
      this.finderData.admin.searchTags = []
    } else if (tag) {
      if (tag.value === 'hd')
        this.finderData.admin.hd.hd = false;
      else if (tag.value === 'nHd')
        this.finderData.admin.hd.nHd = false;
      else if (tag.value === 'xhd')
        this.finderData.admin.xhd.xhd = false;
      else if (tag.value === 'nxHd')
        this.finderData.admin.xhd.nxHd = false;
      else if (tag.value === 'note')
        this.finderData.admin.note.note = false;
      else if (tag.value === 'nNote')
        this.finderData.admin.note.nNote = false;
      else if (tag.value === 'limit') {
        this.limit = new FormControl()
        this.finderData.admin.limit = 15;
      } else if (tag.value === 'damage') {
        this.finderData.admin.damageSearch = false;
      } else if (tag.value === 'annotate') {
        this.finderData.admin.annotateSearch = false;
      } else {
        Object.values(this.finderData.admin.searchTagList).forEach(list => {
          if (list)
            list.forEach(element => {
              if (element.value === tag.value)
                element.checked = false;
            });
        });
      }
    }
    this.validate()
  }

  showDropdown() {
    $("#dropdownadmin").toggleClass("active");
  }

  focusInput(value) {
    if (value)
      $('#search-wrapper').addClass('focused');
    else
      $('#search-wrapper').removeClass('focused');
  }

  editListCheckbox(event?) {
    Object.values(this.finderData.admin.searchTagList).forEach(list => {
      if (list)
        list.forEach(element => {
          let index = this.finderData.admin.searchTags.findIndex(d => { return d.value === element.value });
          if (element.checked === true && index === -1) {
            this.finderData.admin.searchTags.push({ display: element.value.toString(), value: element.value })
          }
          else if (index !== -1 && element.checked === false)
            this.finderData.admin.searchTags.splice(index, 1);
        });
    });
  }

  validate() {
    $("#dropdownadmin").removeClass("active");
    if (!this.finderData || !this.finderData.admin)
      return;

    this.finderData.skip = 0;
    if (this.finderData.admin.limit && this.finderData.admin.limit !== null)
      this.finderData.limit = this.finderData.admin.limit;
    else
      this.finderData.limit = 15;

    if (this.finderData.admin.hd.hd || this.finderData.admin.hd.nHd) {
      if ((this.finderData.admin.hd.hd === true && this.finderData.admin.hd.nHd === true)
        || (this.finderData.admin.hd.hd === false && this.finderData.admin.hd.nHd === false))
        this.finderData.isPicturesHD = undefined;
      else if (this.finderData.admin.hd.hd === true)
        this.finderData.isPicturesHD = true;
      else
        this.finderData.isPicturesHD = false;
    }
    else
      this.finderData.isPicturesHD = undefined;

    if (this.finderData.admin.xhd.xhd || this.finderData.admin.xhd.nxHd) {
      if ((this.finderData.admin.xhd.xhd === true && this.finderData.admin.xhd.nxHd === true)
        || (this.finderData.admin.xhd.xhd === false && this.finderData.admin.xhd.nxHd === false))
        this.finderData.isPicturesXHD = undefined;
      else if (this.finderData.admin.xhd.xhd === true)
        this.finderData.isPicturesXHD = true;
      else
        this.finderData.isPicturesXHD = false;
    }
    else
      this.finderData.isPicturesXHD = undefined;

    if (this.finderData.admin.note.note || this.finderData.admin.note.nNote) {
      if ((this.finderData.admin.note.note === true && this.finderData.admin.note.nNote === true)
        || (this.finderData.admin.note.note === false && this.finderData.admin.note.nNote === false))
        this.finderData.scanAnnotated = undefined
      else if (this.finderData.admin.note.note === true)
        this.finderData.scanAnnotated = true;
      else
        this.finderData.scanAnnotated = false;
    }
    else
      this.finderData.scanAnnotated = undefined

    console.log("test finder admin search : ",
      this._searchService.finderDataAdminHistory, JSON.stringify(this.finderData.admin.searchTags),
      this._searchService.finderDataAdminHistory !== JSON.stringify(this.finderData.admin.searchTags))

    if (this._searchService.finderDataAdminHistory !== undefined
      && this._searchService.finderDataAdminHistory === JSON.stringify(this.finderData.admin.searchTags))
      return

    this.changeAdminData.emit();

  }


  onChangeShowReload() {
    if (this.finderData.admin.damageSearch && this.finderData.admin.searchTags.every(t => { return t.value !== "damage" }))
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'notDamage',
        value: "Ce n\'est pas un dommage",
        description: "Ce n\'est pas un dommage",
        meaning: "finder_admin"
      }), value: "damage" })
    if (this.finderData.admin.annotateSearch && this.finderData.admin.searchTags.every(t => { return t.value !== "annotate" }))
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'notAnnotate',
        value: "Ce n\'est pas une annotation",
        description: "Ce n\'est pas une annotation",
        meaning: "finder_admin"
      }), value: "annotate" })
  }

  onChangeShow(type: string, event: boolean) {
    this.editListCheckbox()
    if (type === 'damage' && event === true) {
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'damage',
        value: "Ce n\'est pas un dommage",
        description: "Ce n\'est pas un dommage",
        meaning: "finder_admin"
      }), value: "damage" })
    } else if (type === 'damage' && event === false) {
      let index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'damage' });
      if (index !== -1)
        this.finderData.admin.searchTags.splice(index, 1)
    } else if (type === 'annotate' && event === true) {
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'annotate',
        value: "Ce n\'est pas une annotation ",
        description: "Ce n\'est pas une annotation",
        meaning: "finder_admin"
      }), value: "annotate" })
    } else if (type === 'annotate' && event === false) {
      let index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'annotate' });
      if (index !== -1)
        this.finderData.admin.searchTags.splice(index, 1)
    }
  }

  onChange(event?) {
    let index: number;

    this.finderData.admin.limit = this.limit.value;
    if (this.finderData.admin.limit < 15) {
      this.finderData.admin.limit = 15
      this.limit.setValue(15)
    }

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'hd' });
    if (this.finderData.admin.hd.hd === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'scanHd',
        value: "Ce n\'est pas un scan HD ",
        description: "Ce n\'est pas un scan HD",
        meaning: "finder_admin"
      }), value: "hd" })
    else if (index !== -1 && this.finderData.admin.hd.hd !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'nHd' });
    if (this.finderData.admin.hd.nHd === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'nonHd',
        value: "Ce n\'est pas un Scan HD",
        description: "Ce n\'est pas un Scan HD",
        meaning: "finder_admin"
      }), value: "nHd" })
    else if (index !== -1 && this.finderData.admin.hd.nHd !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'xhd' });
    if (this.finderData.admin.xhd.xhd === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'scanExtract',
        value: "Ce n\'est pas un scan extract",
        description: "Ce n\'est pas un scan extact",
        meaning: "finder_admin"
      }), value: "xhd" })
    else if (index !== -1 && this.finderData.admin.xhd.xhd !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'nxHd' });
    if (this.finderData.admin.xhd.nxHd === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'nonScanExtract',
        value: "Ce n\'est pas un Scan Extract",
        description: "Ce n\'est pas un Scan Extract",
        meaning: "finder_admin"
      }), value: "nxHd" })
    else if (index !== -1 && this.finderData.admin.xhd.nxHd !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'note' });
    if (this.finderData.admin.note.note === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'annotatedScan',
        value: "C\'est un Scan Annoté",
        description: "C\'est un Scan Annoté",
        meaning: "finder_admin"
      }), value: "note" })
    else if (index !== -1 && this.finderData.admin.note.note !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'nNote' });
    if (this.finderData.admin.note.nNote === true && index === -1)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'nonAnnotated',
        value: "Ce n\'est pas un Scan Annoté",
        description: "Ce n\'est pas un Scan Annoté",
        meaning: "finder_admin"
      }), value: "nNote" })
    else if (index !== -1 && this.finderData.admin.note.nNote !== true)
      this.finderData.admin.searchTags.splice(index, 1)

    index = this.finderData.admin.searchTags.findIndex(d => { return d.value === 'limit' });
    if (index !== -1)
      this.finderData.admin.searchTags.splice(index, 1)
    if (this.finderData.admin.limit !== null && this.finderData.admin.limit !== 15)
      this.finderData.admin.searchTags.push({ display: this.i18n({
        id: 'limit',
        value: "Ce n\'est pas une limite",
        description: "Ce n\'est pas une limite",
        meaning: "finder_admin"
      }) + this.finderData.admin.limit, value: "limit" })

  }

}



// WEBPACK FOOTER //
// ./src/app/element/finder-admin/finder-admin.component.ts